import React from 'react'
import ModalPopup from '../common/ModalPopup'

export const AutoFavoriteMessage = ({ items, closeAutoFavorite }) => (
  <div className="first-order">
    {items && (
      <div className="row center-xs">
        <h2 className="title">New Favorite</h2>
        <p>
          You've ordered{' '}
          <strong>{items.map(item => item.displayText).join(', ')}</strong>{' '}
          multiple times so we've favorited this item for you.
        </p>
        <p className="row center-xs autoFavorite">
          If you wish to remove the item as a favorite, please click on the star
          next to the menu item.
        </p>
        <button className="primary" onClick={() => closeAutoFavorite()}>
          Close
        </button>
      </div>
    )}
  </div>
)

export const AutoFavoriteModal = ({ items, closeAutoFavorite }) => (
  <ModalPopup showCancel={false}>
    <AutoFavoriteMessage items={items} closeAutoFavorite={closeAutoFavorite} />
  </ModalPopup>
)

export default AutoFavoriteModal
